import { EventResultFieldDef } from './models';

export type ResultFieldValues = Record<string, number | null>;

export function emptyResultFieldValues(resultFields: EventResultFieldDef[]): ResultFieldValues {
    const values: ResultFieldValues = {};
    for (const field of resultFields) {
        values[String(field.id)] = null;
    }
    return values;
}

/**
 * Field values pre-filled from an already-stored result, for editing rather than
 * entering from scratch. Any field the stored result has no value for (the organiser
 * added a field after the result was reported) stays empty rather than defaulting to
 * zero, so it reads as "needs a value" instead of a real score of nil.
 */
export function seedResultFieldValues(resultFields: EventResultFieldDef[], stored?: Record<string, number>): ResultFieldValues {
    const values: ResultFieldValues = {};
    for (const field of resultFields) {
        const key = String(field.id);
        values[key] = stored?.[key] ?? null;
    }
    return values;
}

/**
 * Whether every field a player actually has to enter a number for has one, on both
 * sides. A from_outcome field is excluded: the server fills it in from the event's
 * outcomeValues once the outcome is known, so a player can never have a value for it
 * to enter, and requiring one here would leave the submit button permanently disabled.
 */
export function allResultFieldsFilled(
    resultFields: EventResultFieldDef[],
    myValues: ResultFieldValues,
    opponentValues: ResultFieldValues
): boolean {
    return resultFields
        .filter((field) => field.outcomeMode !== 'from_outcome')
        .every((field) => {
            const key = String(field.id);
            return myValues[key] != null && opponentValues[key] != null;
        });
}

export function toResultValuesPayload(resultFields: EventResultFieldDef[], values: ResultFieldValues): Record<string, number> {
    const payload: Record<string, number> = {};
    for (const field of resultFields) {
        payload[String(field.id)] = values[String(field.id)] ?? 0;
    }
    return payload;
}
